// extracted by mini-css-extract-plugin
module.exports = {"container768":"_5YekT","root":"_33Mm2","warning":"_3mo5h"};